import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ModalPortal from "../lib/modalPortal";
import LegalService from "../../rest/legalService";

const LegalAcceptanceGate = () => {
    const [pendingDocuments, setPendingDocuments] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [checked, setChecked] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        let active = true;

        LegalService.getPendingDocuments()
            .then((docs) => { if (active) setPendingDocuments(docs || []); })
            .catch(() => { if (active) setPendingDocuments([]); })
            .finally(() => { if (active) setLoaded(true); });

        return () => { active = false; };
    }, []);

    if (!loaded || pendingDocuments.length === 0) return null;

    const currentDocument = pendingDocuments[activeIndex];
    const isLastDocument = activeIndex === pendingDocuments.length - 1;

    const handleContinue = async () => {
        if (!checked || submitting) return;
        setSubmitting(true);

        try {
            await LegalService.acceptDocument(currentDocument.documentType, currentDocument.version);

            if (isLastDocument) {
                setPendingDocuments([]);
            } else {
                setActiveIndex(prev => prev + 1);
                setChecked(false);
            }
        } catch (error) {
            console.error(error);
            toast.error("Não foi possível registrar o aceite. Tente novamente.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <ModalPortal>
            <div className="fixed inset-0 bg-black/60 z-[100] flex items-center justify-center p-4">
                <div className="bg-white w-full max-w-2xl max-h-[85vh] rounded-2xl shadow-2xl flex flex-col overflow-hidden">
                    <div className="px-6 py-4 border-b border-slate-100">
                        <h2 className="text-lg font-bold text-slate-800">{currentDocument.title}</h2>
                        <p className="text-xs text-slate-400 mt-1">
                            Documento {activeIndex + 1} de {pendingDocuments.length} — leia com atenção antes de continuar
                        </p>
                    </div>

                    <div className="flex-1 overflow-y-auto px-6 py-4 text-sm text-slate-600 whitespace-pre-wrap">
                        {currentDocument.content}
                    </div>

                    <div className="border-t border-slate-100 px-6 py-4 bg-slate-50">
                        <label className="flex items-start gap-2 cursor-pointer select-none mb-4">
                            <input
                                type="checkbox"
                                checked={checked}
                                onChange={(e) => setChecked(e.target.checked)}
                                className="mt-1 w-4 h-4"
                            />
                            <span className="text-sm text-slate-700">
                                Li e aceito os termos do documento &quot;{currentDocument.title}&quot;.
                            </span>
                        </label>

                        <button
                            onClick={handleContinue}
                            disabled={!checked || submitting}
                            className="w-full bg-custom_blue text-white font-bold py-3 rounded-xl shadow-md disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {submitting ? "Enviando..." : isLastDocument ? "Aceitar e continuar" : "Aceitar e ver próximo"}
                        </button>
                    </div>
                </div>
            </div>
        </ModalPortal>
    );
};

export default LegalAcceptanceGate;
